// ServiceItemChildren — part of the product option modal (ProductOptionView).
import { getVariantServiceItemEntries, variantDeclaresServiceItems } from '../normalize';
import OptionPriceDelta from './OptionPriceDelta.jsx';

export default function ServiceItemChildren({
  group,
  selectedOption,
  selections,
  onToggle,
  priceContext,
  t,
}) {
  if (!variantDeclaresServiceItems(selectedOption)) return null;

  const entries = getVariantServiceItemEntries(selectedOption, priceContext);
  if (!entries.length) return null;

  const variantGroupId = group.variant_group_id ?? (group.id === 'single-variants' ? '' : group.id);
  const variantId = selectedOption?.variant_id ?? selectedOption?.id;
  const directEntries = entries.filter((entry) => !entry.groupName);
  const groupedEntriesByGroup = entries
    .filter((entry) => entry.groupName)
    .reduce((map, entry) => {
      const key = entry.serviceItemGroupId || entry.groupName;
      if (!map.has(key)) {
        map.set(key, {
          serviceItemGroupId: entry.serviceItemGroupId,
          groupName: entry.groupName,
          entries: [],
        });
      }
      map.get(key).entries.push(entry);
      return map;
    }, new Map());

  const renderServiceChip = (entry) => {
    const { item, serviceItemGroupId } = entry;
    const key = `${variantGroupId || 'single-variants'}::${variantId}::${serviceItemGroupId || ''}::${item.service_item_id}`;
    const groupScope = serviceItemGroupId
      ? `${variantGroupId || 'single-variants'}::${variantId}::${serviceItemGroupId}::`
      : '';
    const soldOut = item.isSoldOut;
    const selected = !soldOut && (item.isMandatory || Boolean(selections[key]));
    return (
      <button
        key={key}
        type="button"
        aria-pressed={selected}
        disabled={item.isMandatory || soldOut}
        onClick={() => !soldOut && onToggle(key, groupScope)}
        className={`po-chip ${selected ? 'is-selected' : ''} ${soldOut ? 'is-disabled' : ''}`}
      >
        <span>{item.name}</span>
        {soldOut ? (
          <span className="po-chip-delta">{t('outOfStock', 'Out of stock')}</span>
        ) : item.priceDelta ? (
          <OptionPriceDelta amount={item.priceDelta} className="po-chip-delta" />
        ) : null}
      </button>
    );
  };

  return (
    <div className="po-children">
      {directEntries.length > 0 ? (
        <div className="po-child-block">
          <div className="po-child-label">
            <span className="po-child-label-title">{t('serviceItems', 'Service items')}</span>
            <span className="po-child-label-hint">{t('optionalAddOn', 'optional add-on')}</span>
          </div>
          <div className="po-chip-row">{directEntries.map(renderServiceChip)}</div>
        </div>
      ) : null}
      {Array.from(groupedEntriesByGroup.values()).map((serviceGroup) => (
        <div
          key={serviceGroup.serviceItemGroupId || serviceGroup.groupName}
          className="po-child-block"
        >
          <div className="po-child-label">
            <span className="po-child-label-title">{serviceGroup.groupName}</span>
            <span className="po-child-label-hint">{t('optionalAddOn', 'optional add-on')}</span>
          </div>
          <div className="po-chip-row">
            {serviceGroup.entries.map((entry) =>
              renderServiceChip({
                ...entry,
                serviceItemGroupId: serviceGroup.serviceItemGroupId,
              }),
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
